"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgRealityMesh(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm10.5373 10.58-2.5373 1.6925v2.5475l2.5373-1.7857zm-.5942-8.8782-1.9431.9232v5.3365l1.9379.03zm4.9469 1.9989-2.39 1.3927-.0537 5.7588 2.4443-.5436zm-9.5058 3.0762-2.3892 1.34.04 3.0014 2.2594-1.06z', opacity: 0.66 }),
        React.createElement("path", { d: 'm16 3-3.2-1-1.9449.884.1449-1.884-3-1-3 1 .3627 4.7147-2.1159-.711-3.2468 1.0911.5 4.4052 7.5 5.5 7.5-5.5v-1l-.3948-.2369zm-9.9431-1.2982 1.9431-.6477 1.9431.6477-.1274 1.6546-.3157.1436v2.4l.0425 1.0082-1.5425.9256-1.5425-.9255-.0284-.3683.0646-.4448-.1014-.0341zm-4.9721 5.0834 2.162-.7266 2.1373.7183-.4457 3.0705-1.9037 1.2713-1.59-1.1663zm9.4152 6.2-2.5 1.7859-2.5-1.7857v-2.4054l2.5-1.4283 2.5 1.4283zm3.5367-3.3135-1.59 1.09-1.9467-1.2969v-5.3209l2.3662-1.0756 2.0236.6324z' })));
}
exports.default = SvgRealityMesh;
